type RuntimeEnv = Record<string, string | undefined>;

declare global {
  interface Window {
    __ENV?: RuntimeEnv;
  }
}

/**
 * Resolve an env var at runtime first (window.__ENV, injected by an nginx
 * entrypoint in production) then fall back to Vite build-time env (local dev).
 * Mirrors the dashboard's env.ts.
 */
export function getEnv(key: string): string | undefined {
  const runtime = typeof window !== "undefined" ? window.__ENV : undefined;
  if (runtime && runtime[key] != null) return runtime[key];
  return (import.meta as unknown as { env?: RuntimeEnv }).env?.[key];
}
